/**
 * Browser download seam (WP-F11a-follow-up). Two small seams, kept here so the reference-PDF export
 * is spyable in tests without touching jsdom's fetch/navigation internals:
 *
 *  - {@link fetchPdfBlob} fetches the short-TTL (~5-min) presigned R2 GET the backend hands back and
 *    reads it as a Blob. Fetching (rather than opening the URL in a tab) lets us save it as a real
 *    file with a friendly name via a same-origin object URL — a cross-origin presigned URL ignores
 *    the anchor `download` attribute, but the object URL we mint from the Blob honours it.
 *  - {@link saveBlob} triggers the actual "Save as…" for that Blob and releases the object URL.
 */

/** Fetch a presigned URL and read it as a Blob. Throws on a non-2xx (an expired / again-locked link). */
export async function fetchPdfBlob(url: string): Promise<Blob> {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`PDF download failed with status ${response.status}`);
  }
  return response.blob();
}

/** Save a Blob to disk under `filename` via a same-origin object URL + anchor download. */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
